import { handleResponseError } from "./errorHandlingService";

export function deleteUserAccount(event, user, showMessage, refresh){
    event.preventDefault();

    user.deleteUser(user)
        .then(response => {
            if (response.status === 200){
                showMessage(null, "Account wurde gelöscht", "success");
                refresh();
            }
        })
        .catch(err => {
            handleResponseError(err, [
                {
                    status: 404,
                    message: `Der Benutzer mit ID=${user.id} existiert nicht.`
                }
            ])
        });
}
